angular
  .module("AccountingBoxApp")
  .controller("HeaderCtrl", function(
    $scope,
    $rootScope,
    $location,
    Auth
  ) {

    $scope.isCollapsed = true;
    $scope.isLoggedIn = Auth.isLoggedIn;
    // $scope.isAdmin = Auth.isAdmin;
    $scope.getCurrentUser = Auth.getCurrentUser;


    $scope.goToCompanies=function() {
      $rootScope.goToState('app.bookkeeper.companies');
    };

    $rootScope.convertDemo = function() {
      var company = _.clone($rootScope.currentCompany, true);
      $rootScope.$broadcast("editCompany", company);
      $("#companySettingsModal").modal("show");
      analytics.track("Clicked Convert Demo Account");
    };

    $rootScope.$on("companySaved", function(e, company) {
      $("#companySettingsModal").modal("hide");
    });
  });
